import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Hot from "./components/Hot";
import Channel from "./components/Channel";
import Timeline from "./components/Timeline";
import Story from "./components/Story";
import About from "./components/About";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Hot />
        <Channel />
        <Timeline />
        <Story />
        <About />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}